import type { AgentReference, AgentReferenceType } from '@nest-react/domain';

const errorMessage = async (response: Response): Promise<string> => {
  const body = (await response.json().catch(() => ({}))) as {
    message?: string | string[];
  };
  return Array.isArray(body.message)
    ? body.message.join(', ')
    : (body.message ?? `Reference request failed (${response.status})`);
};

export const listWorkspaceAgentReferences = async (
  apiUrl: string,
  workspaceId: string,
  fetcher: typeof fetch = fetch
): Promise<AgentReference[]> => {
  const response = await fetcher(
    `${apiUrl}/workspaces/${workspaceId}/agent/plans/references/workspace`,
    { credentials: 'include' }
  );
  if (!response.ok) throw new Error(await errorMessage(response));
  return (await response.json()) as AgentReference[];
};

export const saveWorkspaceAgentReference = async ({
  apiUrl,
  workspaceId,
  sourceAssetId,
  name,
  type = 'object',
  sessionId,
  fetcher = fetch,
}: {
  apiUrl: string;
  workspaceId: string;
  sourceAssetId: string;
  name: string;
  type?: AgentReferenceType;
  sessionId?: string;
  fetcher?: typeof fetch;
}): Promise<AgentReference> => {
  const response = await fetcher(
    `${apiUrl}/workspaces/${workspaceId}/agent/plans/references/workspace`,
    {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ sourceAssetId, name, type, sessionId }),
    }
  );
  if (!response.ok) throw new Error(await errorMessage(response));
  return (await response.json()) as AgentReference;
};
